import './style.css';

const Footer = () => {
  return (
    <footer className="general_footer">
      <span className="copyright">ASÜFORUM, {new Date().getFullYear()}.</span>
      
      <ul>
        <li className="footer_link">
          <a href="https://github.com/xrystalll" target="_blank" rel="noopener noreferrer">İletişim için</a>
        </li>
      </ul>
    </footer>
  )
}

export default Footer;
